import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import Spinner from '../../App/Components/Spinner/Spinner'
import { Button } from '../../Common/Button'
import { Flex } from '../../Common/Flex'
import { Layout } from '../../Common/Layout'
import { H1 } from '../../Common/Typography'
import { BaseAbsenceCard } from '../layout/AbsenceFormBase/components/BaseAbsenceCard'

import { TitleWrapper } from './style'
import { useGetGeneralAbsenceListQuery } from './util/useGeneralAbsenceQuery'

const options = [
  {
    id: 1,
    icon: 'island-tropical',
    value: 'add_holiday',
    label: 'Add holiday',
    link: '/hr/general-absences/holidays',
  },
]

export const GeneralAbsenceOverViewPage = () => {
  const { data, status, isRefetching } = useGetGeneralAbsenceListQuery()

  const { t } = useTranslation()
  const history = useHistory()

  if (status === 'pending') {
    return <Spinner />
  }

  if (status === 'error') {
    return <p>something went wrong</p>
  }

  return (
    <Layout>
      <TitleWrapper>
        <H1> {t('General absence')}</H1>
        <Flex>
          <Button
            variant={{ type: 'button-main' }}
            onClick={() => history.push('/hr/general-absences/add')}>
            {t('Add general absence')}
          </Button>
          <Button
            variant={{ type: 'button-dropdown', options }}
            onChange={value => console.log('returned value', value)}
          />
        </Flex>
      </TitleWrapper>
      <Box m={3} p={2}>
        {data.map(absence => (
          <BaseAbsenceCard
            key={absence.uuid}
            absenceInfo={absence}
            isRefetching={isRefetching}
            pageType={'general-absence'}
          />
        ))}
      </Box>
    </Layout>
  )
}
